import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

const USER_KEY = 'ops_user'

export const useUserStore = defineStore('user', () => {
  const userInfo = ref(JSON.parse(localStorage.getItem(USER_KEY) || '{}'))

  const isLoggedIn = computed(() => Object.keys(userInfo.value).length > 0)
  const isAdmin = computed(() => !!userInfo.value?.isAdmin)

  function setUserInfo(info) {
    userInfo.value = info
    localStorage.setItem(USER_KEY, JSON.stringify(info))
  }

  function logout() {
    userInfo.value = {}
    localStorage.removeItem(USER_KEY)
  }

  return {
    userInfo,
    isLoggedIn,
    isAdmin,
    setUserInfo,
    logout
  }
})
